/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React, { useState } from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    filterProps,
} from '../../../Abstrap/Abstrap';

import PasswordSymbol from '../FormField/PasswordSymbol/PasswordSymbol';
import FormInput from '../FormInput/FormInput';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const FormInputPassword = (props) => {
    const [visible, setVisible] = useState(true);

    const onClick = () => {
        setVisible((prevState) => !prevState);
    };

    return (
        <>
            <FormInput
                {...filterProps(propTypes, props)}
                type={visible ? 'password' : 'text'}
            />
            <PasswordSymbol
                visible={visible}
                onClick={onClick}
            />
        </>
    );
};

FormInputPassword.propTypes = propTypes;

FormInputPassword.defaultProps = defaultProps;

export default FormInputPassword;
